export const findUnitNumberByLessonId = (lessonData, lessonId) => {
  if (!Array.isArray(lessonData)) return null;
  return lessonData.find((unit) => Array.isArray(unit.lessons)
    && unit.lessons.some((lessonDetail) => lessonDetail.lessonId === lessonId))?.unitNumber || null;
};
